const THRESHOLD = 70; // px of actual finger travel needed to trigger a refresh on release
const RESISTANCE = 0.5; // pull feels heavier than a 1:1 drag, standard pull-to-refresh feel
const INDICATOR_HEIGHT = 60;

export function initPullToRefresh(indicator: HTMLElement, onRefresh: () => Promise<unknown>) {
  let startY = 0;
  let pulling = false;
  let refreshing = false;

  const setDistance = (distance: number) => {
    indicator.style.transform = `translateY(${distance - INDICATOR_HEIGHT}px)`;
    indicator.textContent = distance >= THRESHOLD ? '↻' : '↓';
  };

  document.addEventListener('touchstart', (e) => {
    if (window.scrollY === 0 && !refreshing) {
      startY = e.touches[0].clientY;
      pulling = true;
      indicator.style.transition = 'none';
    }
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!pulling || refreshing) return;
    const delta = e.touches[0].clientY - startY;
    if (delta <= 0) return;

    e.preventDefault(); // we're driving this gesture now, don't also let the page bounce
    setDistance(Math.min(delta * RESISTANCE, THRESHOLD * 1.4));
  }, { passive: false });

  document.addEventListener('touchend', async () => {
    if (!pulling || refreshing) return;
    pulling = false;

    const match = /translateY\((-?[\d.]+)px\)/.exec(indicator.style.transform);
    const distance = match ? parseFloat(match[1]) + INDICATOR_HEIGHT : 0;
    indicator.style.transition = 'transform 0.2s ease';

    if (distance < THRESHOLD) {
      setDistance(0);
      return;
    }

    refreshing = true;
    indicator.classList.add('refreshing');
    indicator.textContent = '↻';
    indicator.style.transform = 'translateY(0)';
    try {
      await onRefresh();
    } finally {
      refreshing = false;
      indicator.classList.remove('refreshing');
      setDistance(0);
    }
  });
}
